import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import VehicleView from "@/common/components/Entity/Vehicle/View/VehicleView";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

interface Props {
  contract: ContractDto;
  viewVariant?: ViewVariant;
}

export default function VehicleTabContent({ contract, viewVariant }: Props) {
  return (
    // todo: refactor
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <VehicleView
          vehicleId={contract.vehicle?.id}
          vehicle={undefined}
          displayProps={{
            breadcrumbs: false,
            header: false,
            actions: true,
            viewVariant: ViewVariant.Tab,
          }}
          headerProps={{
            withLink: true,
            typographyProps: pageTabHeaderTypographyProps.title,
          }}
          onDelete={null}
        />
      </Stack>
    </PageTabContent>
  );
}
